import { createContext } from "react";

export const teacherContext = createContext();